<template>
  <div>
    <panel :title="$t('studentScoringEntry.studentList')">
      <ts-loading-banner :loading="loading">
        <div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th>{{ $t('studentScoringEntry.photo') }}</th>
                <th>{{ $t('studentScoringEntry.studentName') }}</th>
                <th>{{ $t('studentScoringEntry.sex') }}</th>
                <th>{{ $t('studentScoringEntry.phoneNumber') }}</th>
                <th style="width: 10px">{{ $t('actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(student, index) in student_list" :key="index">
                <td class="with-img">
                  <img
                    class="height-30 ts-rounded"
                    v-lazy="{
                      src: photoStudent(student.student_profile),
                      error: onError(student.student_profile),
                      loading: require('@/assets/Rolling-1s-200px_2.svg'),
                    }"
                  />
                </td>
                <td>{{ student.student_profile.full_name_en }}</td>
                <td>{{ student.student_profile.gender }}</td>
                <td>{{ student.student_profile.phone }}</td>
                <td class="text-center ts-whitespace-no-wrap">
                  <a
                    href="#"
                    class="mr-2 btn btn-xs btn-primary"
                    v-if="allowInput"
                    v-tooltip="$t('studentScoringEntry.entryScore')"
                    @click.prevent="entryScore(student)"
                  >
                    <i class="fas fa-pen"></i>
                  </a>
                  <!-- <a
                    href="#"
                    class="mr-2 btn btn-xs btn-info"
                    v-if="allowInput"
                    v-tooltip="$t('studentScoringEntry.dayAbsent')"
                    @click.prevent="dayAbsent(student)"
                  >
                    <i class="fas fa-user-clock"></i>
                  </a> -->
                  <a
                    href="#"
                    v-if="model.scoring_cycle_id == 4"
                    class="mr-2 btn btn-xs btn-info"
                    @click.prevent="onAdvisorComment(student)"
                    v-tooltip="$t('studentScoringEntry.commentYearly')"
                  >
                    <i class="fas fa-comment-alt"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- numeric scoring entry -->
          <a-modal
            v-if="numeric_scoring"
            v-model="numeric_scoring"
            :zIndex="1020"
            width="100%"
            wrap-class-name="full-modal"
            title="Numbering Scoring Entry"
            :footer="null"
          >
            <numeric-scoring-entry
              v-model="model"
              @closeModal="() => (numeric_scoring = false)"
              :class-operations="classOperations"
              :student-profiles="entry_on_student_profiles"
              :ignore-scoring-on-cycle="ignore_scoring_on_cycle"
              :enable-rating-on-cycle="enable_rating_on_cycle"
              :grade-id="paramsGetComponentForGrading.grade_id"
              :acps-id="paramsGetComponentForGrading.acps_id"
            />
          </a-modal>
          <!-- grading scoring entry -->
          <a-modal
            v-if="grading_scoring"
            v-model="grading_scoring"
            :zIndex="1020"
            title="Grading Scoring Entry"
            width="100%"
            wrap-class-name="full-modal"
            :footer="null"
          >
            <grading-scoring-entry
              v-model="model"
              @closeModal="() => (grading_scoring = false)"
              :params-get-component="paramsGetComponentForGrading"
              :class-operations="classOperations"
              :student-profiles="entry_on_student_profiles"
              :ignore-scoring-on-cycle="ignore_scoring_on_cycle"
              :enable-rating-on-cycle="enable_rating_on_cycle"
            />
          </a-modal>
          <!-- rating scoring entry -->
          <a-modal
            v-if="rating_scoring"
            v-model="rating_scoring"
            :zIndex="1020"
            title="Rating Scoring Entry"
            width="100%"
            wrap-class-name="full-modal"
            :footer="null"
          >
            <rating-scoring-entry
              v-model="model"
              @closeModal="() => (rating_scoring = false)"
              :params-get-component="paramsGetComponentForGrading"
              :class-operations="classOperations"
              :student-profiles="entry_on_student_profiles"
              :ignore-scoring-on-cycle="ignore_scoring_on_cycle"
              :enable-rating-on-cycle="enable_rating_on_cycle"
            />
          </a-modal>
          <!-- advisor comment -->
          <a-modal
            v-if="advisor_comment"
            v-model="advisor_comment"
            :zIndex="1020"
            :title="'Student Name : ' + entry_on_student"
            :maskClosable="false"
            width="900px"
            :footer="null"
          >
            <advisor-comment
              v-model="model"
              @closeModal="() => (advisor_comment = false)"
            />
          </a-modal>
          <!-- input day absent -->
          <a-modal
            v-if="day_absent"
            v-model="day_absent"
            :zIndex="1020"
            :title="'Student Name : ' + entry_on_student"
            :maskClosable="false"
            width="500px"
            :footer="null"
          >
            <day-absent
              v-model="model"
              @closeModal="() => (day_absent = false)"
            />
          </a-modal>
        </div>
      </ts-loading-banner>
    </panel>
  </div>
</template>

<script>
import GradingScoringEntry from './grading-score-entry'
import NumericScoringEntry from './numeric-score-entry'
import RatingScoringEntry from './rating-score-entry'
import AdvisorComment from './advisor-comment'
import DayAbsent from './day-absent'

export default {
  name: 'studentListComponent',
  props: ['value', 'classOperations'],
  components: {
    GradingScoringEntry,
    NumericScoringEntry,
    RatingScoringEntry,
    AdvisorComment,
    DayAbsent
  },
  data() {
    return {
      paramsGetComponentForGrading: {
        grade_id: 0,
        sc_bas_id: null,
        acps_id: null,
      },
      model: {},
      loading: false,
      numeric_scoring: false,
      grading_scoring: false,
      rating_scoring: false,
      advisor_comment: false,
      param_props: [],
      student_list: [],
      boyPhoto: require('../../../assets/student-default-boy.png'),
      girlPhoto: require('../../../assets/student-default-girl.png'),
      entry_on_student: 'Unknow',
      entry_on_student_profiles: null,
      ignore_scoring_on_cycle: [],
      enable_rating_on_cycle: [],
      day_absent: false
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    allowInput() {
      return (
        this.model.class_id !== null &&
        this.model.scoring_cycle_id !== null &&
        // this.model.scoring_cycle_id !== 4 &&
        this.model.cycle_value !== null
      )
    },
  },
  methods: {
    fetchStudentListHasEnroll() { // filter subject hard code by session id customize for idea
      if(this.model.class_id == null || this.model.session_id == null) return 
      this.student_list = []
      this.loading = true
      this.$store
        .dispatch('studentScoringEntry/getStudentEnrollmentByClass', { class_id: this.model.class_id, session_id: this.model.session_id })
        .then((response) => {
          this.student_list = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    photoStudent(record) {
      if (record.photo) {
        return record.photo
      }
      return record.gender == 'Male' ? this.boyPhoto : this.girlPhoto
    },
    onError(record) {
      event
        ? (event.target.src =
            record.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    entryScore(record) {
      this.ignore_scoring_on_cycle = []
      this.enable_rating_on_cycle = []
      var sc_bas_id = 1 // default is item base
      var scoring_cycle = this.model.scoring_cycle_id
      //ignore entry score for core subject on scoring cycle
      var ignore_scoring_on_cycle = record.academic_class.grade
        .ignore_scoring_on_cycle
        ? record.academic_class.grade.ignore_scoring_on_cycle.split(',')
        : []
      ignore_scoring_on_cycle.map((el) => {
        this.ignore_scoring_on_cycle.push(parseInt(el))
      })
      //Enable rating for entry score for elective subject on scoring cycle
      var enable_rating_on_cycle = record.academic_class.grade
        .enable_rating_on_cycle
        ? record.academic_class.grade.enable_rating_on_cycle.split(',')
        : []
      enable_rating_on_cycle.map((el) => {
        this.enable_rating_on_cycle.push(parseInt(el))
      })
      this.paramsGetComponentForGrading.acps_id = this.model.acps_id

      this.entry_on_student_profiles = record.student_profile
      this.entry_on_student = record.student_profile.full_name_en
      this.model.student_id = record.student_id
      this.model.st_class_id = record.st_class_id
      if (record.academic_class.grade.score_type == 1) {
        // entry score for numberic
        if (scoring_cycle == 1) {
          sc_bas_id = record.academic_class.grade.monthly_score_sc_bas_id
        } else if (scoring_cycle == 2) {
          sc_bas_id = record.academic_class.grade.semester_score_sc_bas_id
        }

        this.numeric_scoring = true
        this.model.score_type = 1
        this.model.sc_bas_id = sc_bas_id
        this.paramsGetComponentForGrading.grade_id =
          record.academic_class.grade.grade_id
      } else if (record.academic_class.grade.score_type == 2) {
        // entry score for grading
        this.paramsGetComponentForGrading.grade_id =
          record.academic_class.grade.grade_id

        if (scoring_cycle == 1) {
          sc_bas_id = record.academic_class.grade.monthly_score_sc_bas_id
        } else if (scoring_cycle == 2) {
          sc_bas_id = record.academic_class.grade.semester_score_sc_bas_id
        }

        this.paramsGetComponentForGrading.sc_bas_id = sc_bas_id

        this.grading_scoring = true
        this.model.score_type = 2
      } else if (record.academic_class.grade.score_type == 3) {
        // entry score for rating
        this.paramsGetComponentForGrading.grade_id =
          record.academic_class.grade.grade_id

        if (scoring_cycle == 1) {
          sc_bas_id = record.academic_class.grade.monthly_score_sc_bas_id
        } else if (scoring_cycle == 2 || scoring_cycle == 0 || scoring_cycle == 7) {
          sc_bas_id = record.academic_class.grade.semester_score_sc_bas_id
        }

        this.paramsGetComponentForGrading.sc_bas_id = sc_bas_id

        this.rating_scoring = true
        this.model.score_type = 3
      }
    },
    onAdvisorComment(record) {
      this.entry_on_student = record.student_profile.full_name_en
      this.model.student_id = record.student_id
      this.model.st_class_id = record.st_class_id
      this.advisor_comment = true
    },
    dayAbsent(record) {
      this.entry_on_student = record.student_profile.full_name_en
      this.model.student_id = record.student_id
      this.model.st_class_id = record.st_class_id
      this.day_absent = true
    },
  },
  watch: {
    'model.class_id': function (id) {
      if (id) {
        this.fetchStudentListHasEnroll()
      }
    },
    'model.session_id': function (id) {
      if (id) {
        this.fetchStudentListHasEnroll()
      }
    },
  },
}
</script>
<style lang="scss">
.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }
  .ant-modal-body {
    flex: 1;
  }
}
</style>
